import { render, staticRenderFns } from "./userStatistics.vue?vue&type=template&id=ad2e470c&"
import script from "./userStatistics.vue?vue&type=script&lang=js&"
export * from "./userStatistics.vue?vue&type=script&lang=js&"
import style0 from "./userStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports